import NewPassword from "./NewPassword";
export {NewPassword};
